import { linePlot, numberInput, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { fillAverageTrueRange } from "../math/trueRange";
import { superTrendAt, SUPER_TREND_UP } from "../math/superTrend";

/**
 * SuperTrend (research §1.4), as TV SuperTrend (Length = ATR, Factor =
 * Multiplier, math/superTrend.js). TV draws one line in two colours, here
 * it is split as in PO: Up is the line over the price (a down trend), Down
 * the line under it (an up trend). No value on the first ATR bars, as in TV.
 * Where the trend turns, a label marks the start of the new line: Buy under
 * Down, Sell over Up (`buy` / `sell`: the line value there, NaN elsewhere).
 */
export default {
  id: "supertrend",
  name: "SuperTrend",
  isOscillator: false,
  inputs: [
    periodInput("atrPeriod", "ATR", 10, { max: 100 }),
    numberInput("multiplier", "Multiplier", 3, { min: 1, max: 5, precision: 2 }),
  ],
  plots: [
    linePlot("up", "Up", PALETTE.RED, { width: 2 }),
    linePlot("down", "Down", PALETTE.LIME, { width: 2 }),
  ],
  labels: [
    { key: "buy", text: "Buy", plotKey: "down", isAbove: false },
    { key: "sell", text: "Sell", plotKey: "up", isAbove: true },
  ],
  buffers: ["atr", "lower", "upper", "line", "direction", "buy", "sell"],
  levels: [],

  calculate: (bars, { atrPeriod, multiplier }, series, fromIndex) => {
    const state = { lower: series.lower, upper: series.upper, line: series.line, direction: series.direction };

    fillAverageTrueRange({ bars, target: series.atr, period: atrPeriod, fromIndex });

    for (let index = fromIndex; index < bars.length; index += 1) {
      superTrendAt(bars, index, series.atr, multiplier, state);

      const line = index >= atrPeriod ? series.line[index] : NaN;
      const isUpTrend = series.direction[index] === SUPER_TREND_UP;
      // The first bar with a value is not a turn
      const isTurn = index > atrPeriod && series.direction[index] !== series.direction[index - 1];

      series.down[index] = isUpTrend ? line : NaN;
      series.up[index] = isUpTrend ? NaN : line;
      series.buy[index] = isTurn && isUpTrend ? line : NaN;
      series.sell[index] = isTurn && !isUpTrend ? line : NaN;
    }
  },
};
